import {Line} from 'vue-chartjs';
import _ from 'lodash';

export default {
    name: 'YearGraph',
    extends: Line,
    data: () => {
        return {
            chartOptions: {
                animation: false,
                title: {
                    display: false
                },
                legend: {
                    display: false
                },
                tooltips: {
                    enabled: true,
                    mode: 'index',
                    axis: 'x',
                    intersect: false,
                },
                scales: {
                    yAxes: [{
                        type: 'linear',
                        ticks: {
                            beginAtZero: true,
                            min: 0,
                            suggestedMax: 1
                        },
                        scaleLabel: {},
                    }],
                    xAxes: [{
                        type: 'time',
                        ticks: {
                            autoSkip: true,
                            maxTicksLimit: 11,
                        },
                        scaleLabel: {},
                        time: {
                            unit: 'month',
                            displayFormats: {
                                month: 'MMM',
                            },
                            tooltipFormat: 'll', // Localized format for showing day, month name (short) and year
                        },
                        gridLines: {
                            display: false
                        },
                    }]
                },
                elements: {
                    line: {
                        tension: 0,
                        fill: false,
                    },
                    point: {
                        radius: 0,
                    },
                },
            },
        };
    },
    props: {
        lines: {type: Array, default: () => ([])},
        labelXaxis: {type: String, default: ''},
        labelYaxis: {type: String, default: ''},
    },
    computed: {
        localizationFormats() {
            return {
                tooltip: this.$t('widgets.year_graph.format_tooltip'),
                display: this.$t('widgets.year_graph.format_label'),
            };
        },
        reactiveHidden() {
            // This computed property interacts with the .hidden property on all datasets, this enables us to watch this
            // property specifically and react to it with a graph update.
            return this.lines.map(line => line.hidden);
        }
    },
    watch: {
        lines: 'updateChart',
        localizationFormats: 'updateChart',
        reactiveHidden: 'updateChart',
        labelXaxis: 'updateChart',
        labelYaxis: 'updateChart',
    },
    mounted() {
        this.updateChart();
    },
    methods: {
        updateChart() {
            this.updateChartOptions();
            const chartData = {
                datasets: this.lines,
                labels: _.times(12, i => new Date(2000, i, 1)),
            };
            this.renderChart(chartData, this.chartOptions);
        },
        updateChartOptions() {
            this.chartOptions.scales.xAxes[0].scaleLabel.display = !!(this.labelXaxis);
            this.chartOptions.scales.xAxes[0].scaleLabel.labelString = this.labelXaxis;
            this.chartOptions.scales.yAxes[0].scaleLabel.display = !!(this.labelYaxis);
            this.chartOptions.scales.yAxes[0].scaleLabel.labelString = this.labelYaxis;
            this.chartOptions.scales.xAxes[0].time.tooltipFormat = this.localizationFormats.tooltip;
        },
    }
};



// WEBPACK FOOTER //
// ./src/components/widgets/year-graph/YearGraph.js